<form
  [formGroup]="formGroup"
  [bitSubmit]="submit"
  bit-dialog
  class="bv-policy-dialog"
  [loading]="loading()"
>
  <ng-container bitDialogTitle>
    @let title = policySteps()[currentStep()]?.titleContent?.();
    @if (title) {
      <ng-container [ngTemplateOutlet]="title"></ng-container>
    } @else {
      <span class="bv-policy-dialog__title">
        {{ "editPolicy" | i18n }}
        @if (!loading()) {
          <span class="bv-policy-dialog__subtitle">{{
            (isV2() ? (policy.v2?.name ?? policy.name) : policy.name) | i18n
          }}</span>
        }
      </span>
    }
  </ng-container>

  @if (isV2()) {
    <ng-container bitDialogHeaderEnd>
      @if (!loading()) {
        @if (policyEnabled()) {
          <span bitBadge variant="success">{{ "on" | i18n }}</span>
        } @else {
          <span bitBadge variant="secondary">{{ "off" | i18n }}</span>
        }
      }
    </ng-container>
  }

  <ng-container bitDialogContent>
    @if (loading()) {
      <div>
        <i
          class="bwi bwi-spinner bwi-spin tw-text-muted"
          title="{{ 'loading' | i18n }}"
          aria-hidden="true"
        ></i>
        <span class="tw-sr-only">{{ "loading" | i18n }}</span>
      </div>
    } @else {
      @if (showDescription()) {
        <p class="bv-policy-dialog__intro">{{ descriptionKey() | i18n }}</p>
      }

      @let bodyTemplate = policySteps()[currentStep()]?.bodyContent?.();
      @if (bodyTemplate) {
        <ng-container [ngTemplateOutlet]="bodyTemplate"></ng-container>
      }
    }
    <!-- Always rendered so viewChild resolves before ngAfterViewInit runs. -->
    <ng-template #policyForm></ng-template>
  </ng-container>

  <ng-container bitDialogFooter>
    @let footerTemplate = policySteps()[currentStep()]?.footerContent?.();
    @if (footerTemplate) {
      <ng-container [ngTemplateOutlet]="footerTemplate"></ng-container>
    } @else {
      <div class="bv-policy-dialog__footer">
        @if (!isV2()) {
          <button
            bitButton
            buttonType="secondary"
            type="button"
            class="bv-policy-dialog__cancel-btn"
            (click)="cancel()"
          >
            {{ "cancel" | i18n }}
          </button>
        }
        <button
          bitButton
          buttonType="primary"
          [disabled]="loading() || saveDisabled()"
          bitFormButton
          type="submit"
        >
          {{ (currentStep() === policySteps().length - 1 ? "save" : "next") | i18n }}
        </button>
      </div>
    }
  </ng-container>
</form>
